import React from 'react'
import './../Mod.css'
function Modstatic({ txt }) {
    return <div className="Mod_root">
        <div className="Mod_subroot">
            {txt}
        </div>
    </div>
}
export default Modstatic